export default __webpack_public_path__ + "static/media/reddit.6181847e.svg";